import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Typography, List, Divider, Button } from '@material-ui/core';
import { DateTime } from 'luxon';
import BoardPost from './BoardPost';
import BoardPostEditor from './BoardPostEditor';

const BoardThreadDetails = ({ thread, onLoadNext, onAddPost, onReact, onUndoReact, submitting, signedIn, satisfyingParticipationConstraints, authenticationRequired }) => {
  return (
    <React.Fragment>
      <Typography variant="h6">{thread.title}</Typography>
      <Typography variant="caption" color="textSecondary" gutterBottom>Utworzono {DateTime.fromISO(thread.createdAt).toFormat('dd.MM.yyyy HH:mm')}</Typography>
      <Divider />
      <List>
        {thread.posts.map((post, index) => (
          <BoardPost
            key={post.id}
            post={post}
            mainPost={index === 0}
            onReact={r => onReact(post, r)}
            onUndoReact={r => onUndoReact(post, r)}
            submitting={submitting}
            signedIn={signedIn}
            closed={thread.closed}
            authenticationRequired={authenticationRequired}
          />)
        )}
      </List>
      {thread.posts.length < thread.postsCount ? <div style={{textAlign: 'center'}}>
        <Button color="primary" variant="outlined" onClick={onLoadNext}>Wczytaj kolejne wpisy ...</Button>
      </div> : null}
      {!thread.closed && !thread.pendingApproval && (authenticationRequired && !signedIn) ? <Typography variant="caption" color="textSecondary" component="p">Udział w dyskusji wymaga zalogowania</Typography> : null}
      {!thread.closed && !thread.pendingApproval && (!authenticationRequired || signedIn) && thread.boardSettings.postsPublicationMode == 'moderated' ? <Typography variant="caption" color="textSecondary" component="p">Wpisy na tym forum przechodzą weryfikację i są widoczne po zaakceptowaniu przez moderatora</Typography> : null}
      {!thread.closed && !thread.pendingApproval && (!authenticationRequired ||signedIn) ? <BoardPostEditor onSubmit={onAddPost} disabled={thread.closed || (authenticationRequired && !signedIn) || (signedIn && !satisfyingParticipationConstraints)} /> : null}
      {signedIn && !satisfyingParticipationConstraints ? <Typography variant="body1" component="p" color="error" style={{ marginTop: 10 }}>Twoje konto nie zostało jeszcze zweryfikowane lub udział w konsultacjach wymaga innego typu konta</Typography> : null}
    </React.Fragment>
  );
};

BoardThreadDetails.propTypes = {
  t: PropTypes.func.isRequired,
  thread: PropTypes.object.isRequired,
  onLoadNext: PropTypes.func.isRequired,
  onAddPost: PropTypes.func.isRequired,
  onReact: PropTypes.func.isRequired,
  onUndoReact: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  signedIn: PropTypes.bool,
  satisfyingParticipationConstraints: PropTypes.bool,
  authenticationRequired: PropTypes.bool,
};

export default translate()(BoardThreadDetails);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/board/BoardThreadDetails.js